import "../css/products";
//import "./components/block-cart";
import { addToCartButton, ctrlTailleChoisie } from "./components/cart";
import { tailleCarreBtn } from "./components/attributes.js";
import { clockTNT } from "./components/clock.js";
import Swiper, { Navigation, Autoplay, EffectFade, Thumbs } from "swiper";
import "swiper/scss";
import "swiper/scss/navigation";
import "swiper/scss/autoplay";
import "swiper/scss/effect-fade";
import "swiper/scss/thumbs";
import "./modules/game/components/grattage"



document.addEventListener('DOMContentLoaded', function () {
  const links = document.querySelectorAll('.scroll-link');
  const headerHeight = document.querySelector('header').offsetHeight;

  links.forEach(link => {
    link.addEventListener('click', function (event) {
      event.preventDefault();
      const targetId = this.getAttribute('href').substring(1);
      const targetElement = document.getElementById(targetId);
      const targetPosition = targetElement.getBoundingClientRect().top - 20 + window.scrollY;
      const offsetPosition = targetPosition - headerHeight;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    });
  });
});




$(document).ready(() => {









  if ($(".product-customization-item").length) {
    console.log('product custom here');
    let element = $(".product-customization-item").find('textarea');



    element.on("keydown", function (event) {
      if (event.key === 'Enter') {
        event.preventDefault(); // Empêche le retour à la ligne
        this.blur(); // Déclenche le focusout (perd le focus)
      }
    });


    element.on("focusout", function () {
      console.log('focusout');
      let value = $(this).val();
      let id_product = element.data('id_product');
      let id_field = element.data('id_field');
      console.log('value : ', value);
      console.log('oryx_ajax_path', oryx_ajax_path);
      $('.spinner-border').fadeIn(200);


      if ($(".product-customization-item").data('id-product-pack').length) {
        console.log('this is a pack');

        // ADD TEXT ON ALL CUSTOM TEXTAREA
        //$('.ap5-customization-form').each(function () {
        //id_product_pack = $(this).attr('data-id-product-pack');
        $('.ap5-customization-block-input').each(function (index, element) {
          $(this).html(value);
          console.log('inside loop for value', value);
          // id_customization_field = $(this).attr('data-id-customization-field');
          // productPackCustomization = {
          //   idProductPack: id_product_pack,
          //   idCustomizationField: id_customization_field,
          //   value: $(this).val(),
          // };
          // productPackCustomizationList.push(productPackCustomization);

        });


        let zoneMessage = $('#product-information').find('.product-customization-item').find('.customization-message');
        if (value === '') {
          $('.spinner-border').fadeOut("slow", function () {
            zoneMessage.find('span').css('display', 'none');
            zoneMessage.find('label').html('');
          });
        }
        else {
          $('.spinner-border').fadeOut("slow", function () {
            zoneMessage.find('span').css('display', 'block');
            zoneMessage.find('label').html('<img width="20" height="20" class="icon done" alt="Fait" src="/modules/oryx/views/img/icons/done.svg">');
          });
        }


      } else {

        $('[data-button-action="add-to-cart"]').prop("disabled", true);

        let data = {
          // controller: 'product',
          action: 'textRecord',
          submitCustomizedData: 1,
          id_product: id_product,
          id_field: id_field,
          //token: tokenAdminOryx,
        }
        data[id_field] = value;

        $.ajax({
          type: 'POST',
          url: oryx_ajax_path,
          //url: 'index.php',
          async: true,
          cache: false,
          dataType: 'json',
          data: data,
          success(json) {
            $('[data-button-action="add-to-cart"]').prop("disabled", false);
            let zoneMessage = $('#product-information').find('.product-customization-item').find('.customization-message');
            if (json.id_customization) {
              $('#product_customization_id').val(json.id_customization);
            }
            if (value === '') {
              $('.spinner-border').fadeOut("slow", function () {
                zoneMessage.find('span').css('display', 'none');
                zoneMessage.find('label').html('');
              });
            }
            else {
              $('.spinner-border').fadeOut("slow", function () {
                zoneMessage.find('span').css('display', 'block');
                zoneMessage.find('label').html('<img width="20" height="20" class="icon done" alt="Fait" src="/modules/oryx/views/img/icons/done.svg">');
              });
            }
          },
          error: function (err) {
            alert('Une erreur est survenue lors de la prise en charge du texte.');
            console.error(err);
          },
          complete: function () {
            $('[data-button-action="add-to-cart"]').prop("disabled", false);
          }
        });
      }
    });
  }



  var timestamp_livraison = parseInt(
    $("#compteur_livraison").data("date_livraison") + "000"
  );
  clockTNT(timestamp_livraison);

  let swipersBig = createSwipersBig();
  let swipersThumb = createSwipersThumb();

  if ($("#ap5-product-list").length) {
    console.log('Inside A PACKS MANIA');

    // Add pack to cart
    $(document).on('submit', 'form.ap5-buy-block', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      const pm_ap5_id_pack = parseInt($('input[name=id_product]').val());
      const pm_ap5_id_product_attribute_list = $('#idCombination').val();
      // console.log('going to add pack to cart');
      // console.log('pm_ap5_id_pack', pm_ap5_id_pack);
      // console.log('pm_ap5_id_product_attribute_list', pm_ap5_id_product_attribute_list);

      const tailleChoisie = ctrlTailleChoisie();

      if (tailleChoisie === false) {
        return false;
      }

      ap5Plugin.addPackToCart(pm_ap5_id_pack, pm_ap5_id_product_attribute_list, $(this));
      return false;
    });
  }

  tailleCarreBtn();




  addToCartButton();

  // $("#product-actions").on("click", ".block-review-item", function (e) {
  //   e.preventDefault();
  //   if ($(".list-review").length) {
  //     $("html, body").animate(
  //       {
  //         scrollTop: $("#anchorReview").offset().top - 100,
  //       },
  //       200,
  //       "linear"
  //     );
  //   }
  // });


  if ($("#product-information").length) {

    $("#product-information").on("click", "#txt_guide_tailles", function (e) {
      e.preventDefault();
      const el = $(this);
      import(
        /* webpackChunkName: "guideTailleImport" */
        "./components/guideTailleImport.js"
      ).then((guidetailleImport) => {
        guidetailleImport.view(el);
      });
    });

    $("#product-information").on("click", ".customizationsssss", function (e) {
      e.preventDefault();
      //console.log('click ok');
      switch (parseInt($(this).data("id_product"))) {
        case 10015:
          window.location.href = "/module/personnalisation/boxerhomme";
          break;

        case 10016:
          window.location.href = "/module/personnalisation/boxerfemme";
          break;

        case 10017:
          window.location.href = "/module/personnalisation/boxergarcon";
          break;

        case 10018:
          window.location.href = "/module/personnalisation/boxerfille";
          break;

        case 10985:
          window.location.href = "/module/personnalisation/mugCeramique";
          break;

        case 10959:
          window.location.href =
            "/module/personnalisation/mugPanoramiqueCeramique";
          break;

        case 10960:
          window.location.href =
            "/module/personnalisation/tapisSourisRectangulaire";
          break;

        case 11311:
          window.location.href = "/module/personnalisation/tapisSourisRond";
          break;

        case 11312:
          window.location.href = "/module/personnalisation/plaqueAluminium2025";
          break;

        case 11313:
          window.location.href = "/module/personnalisation/plaqueAluminium2840";
          break;

        case 11314:
          window.location.href = "/module/personnalisation/plaqueAluminium4040";
          break;

        case 11315:
          window.location.href = "/module/personnalisation/plaqueAluminium5050";
          break;

        default:
          console.log(
            "Sorry, we are out of " + parseInt($(this).data("id_product")) + "."
          );
      }
    });
  }

  let swiperThumb = false;
  if ($("#product-thumb").length) {
    swiperThumb = new Swiper("#product-thumb", {
      modules: [Autoplay],
      preloadImages: false,
      direction: "vertical",
      autoHeight: true,
      grabCursor: true,
      rewind: true,
      speed: 2000,
      autoplay: {
        delay: 2000,
      },
      slidesPerView: 4,
      spaceBetween: 30,
    });
  }

  const swiperBigProduct = new Swiper("#productbig", {
    modules: [Autoplay, EffectFade, Thumbs],
    rewind: true,
    autoplay: {
      delay: 3000,
    },
    autoHeight: true,
    grabCursor: true,
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    thumbs: {
      swiper: swiperThumb,
    },
  });







  if ($("#swiperColorsProducts").length) {
    const swiperColorsProducts = new Swiper("#swiperColorsProducts", {
      modules: [Navigation, Autoplay],
      speed: 2000,
      rewind: true,
      autoplay: {
        delay: 2000,
      },
      slidesPerView: 3,
      spaceBetween: 20,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        // when window width is >= 480px
        480: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        // when window width is >= 640px
        1280: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        1680: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
      },
    });
  }

  var timestamp_livraison = parseInt(
    $("#compteur_livraison").data("date_livraison") + "000"
  );
  clockTNT(timestamp_livraison);


  $(document).on("click", "#close-popup", function (e) {
    e.preventDefault();
    console.log("ok click");
    //$("#blockcart-modal").remove();
    //$(".modal-backdrop").remove();
  });

  prestashop.on("updatedProduct", (event) => {
    //createInputFile();
    //coverImage();
    if (event && event.product_minimal_quantity) {
      const minimalProductQuantity = parseInt(
        event.product_minimal_quantity,
        10
      );
      const quantityInputSelector = prestashop.selectors.quantityWanted;
      const quantityInput = $(quantityInputSelector);

      // @see http://www.virtuosoft.eu/code/bootstrap-touchspin/ about Bootstrap TouchSpin
      quantityInput.trigger("touchspin.updatesettings", {
        min: minimalProductQuantity,
      });
    }
    //imageScrollBox();
    /*$($(prestashop.themeSelectors.product.activeTabs).attr("href"))
      .addClass("active")
      .removeClass("fade");
    $(prestashop.themeSelectors.product.imagesModal).replaceWith(
      event.product_images_modal
    );*/
  });
});


export function createSwipersBig() {
  const swipersBig = new Swiper(".productbigpack", {
    modules: [Autoplay, EffectFade, Thumbs],
    rewind: true,
    autoplay: {
      delay: 3000,
    },
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
  });

  return swipersBig;
}

export function createSwipersThumb() {
  let swipersThumb = {};
  const nbpack = parseInt($("#ap5-product-list").data('nbpackproducts'));
  for (var i = 1; i <= nbpack; i++) {
    if ($("#swiperThumb" + i).length) {
      swipersThumb[i] = new Swiper("#swiperThumb" + i, {
        modules: [Autoplay],
        rewind: true,
        speed: 2000,
        autoplay: {
          delay: 2000,
        },
        slidesPerView: 3,
        spaceBetween: 30,
      });
    }
  }

  return swipersThumb;
}
